<template>
  <div class="book-wrapper">
    <div class="book-cover"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/cover.png" alt=""></div>
    <div class="book-intro">
      <div class="title">《奇想·建筑》</div>
      <div class="sub-title">凯诺优秀设计师倾力奉献</div>
      <div class="price">¥ 29.90 - 78.80<span>¥ 79.00 -197.00</span></div>
      <div class="intro-item post-cast">
        <div class="type">运费</div>
        <div class="content">包邮（限中国大陆地区）</div>
      </div>
      <div class="intro-item post-time">
        <div class="type">发货时间</div>
        <div class="content warn" v-if="isFestival">因春节快递停运，即日起暂停发货，2020年2月3日后恢复发货</div>
        <div class="content" v-else>下单后3个工作日内发货</div>
      </div>
    </div>
    <div class="book-main">
      <div class="book-switch" id="bookSwitch">
        <div class="switch-wrapper" :class="{'fixed': switchFixed}">
          <div class="switch-box">
            <div class="switch-item" :class="{'active': currentBook == 2}" @click="changePage(2)">《奇想2》</div>
            <div class="switch-item" :class="{'active': currentBook == 1}" @click="changePage(1)">《奇想1》</div>
            <div class="active-line" :style="{left: switchLeft + '%'}"></div>
          </div>
        </div>
      </div>
      <div class="book-main-wrapper">
        <!-- 奇想2 -->
        <div class="book-block" v-if="currentBook == 2">
          <div class="main-block">
            <div class="block-title">基本信息</div>
            <div class="base-list">
              <div class="list-item">
                <div class="type">书名</div>
                <div class="content">《奇想·建筑》</div>
              </div>
              <div class="list-item">
                <div class="type">外文名</div>
                <div class="content">《Exacting Fantasy》</div>
              </div>
              <div class="list-item">
                <div class="type">主编</div>
                <div class="content">王斯旻，王雪诗，白非</div>
              </div>
              <div class="list-item">
                <div class="type">页数</div>
                <div class="content">239 页</div>
              </div>
              <div class="list-item">
                <div class="type">装订</div>
                <div class="content">裸脊精装</div>
              </div>
              <div class="list-item">
                <div class="type">出版社</div>
                <div class="content">清华大学出版社</div>
              </div>
              <div class="list-item">
                <div class="type">商品尺寸</div>
                <div class="content">22.5 x 24 x 1.7 cm</div>
              </div>
            </div>
          </div>
          <div class="main-block">
            <div class="block-title">内容简介</div>
            <div class="intro-content">
              <div class="section">互联网、人工智能、区块链、虚拟现实…似乎每个概念都和建筑相关，但又都在其庞大的投资和巨量的协作前无法撼动根基，仿佛建筑行业就应该是那个在时代中跑得最慢的一个，又仿佛慢半拍的建筑已经足够满足人们的需要。 </div>
              <div class="section">本书的作者们想挑战的，就是对于建筑思考的桎梏。作为遍布全球的中国青年设计师，他们在不同的方向上用作品讲述着对建筑未来的认知。这些作品，或探讨形式，或品味乡土，或触摸材料，或剖析社会，它们是从全世界范围征集的数百份作品中选出的佼佼者，作者们试图讨论建筑未来，讨论建筑行业未来，讨论建筑与社会变化间关系的思想先锋。</div>
            </div>
          </div>
          <div class="main-block">
            <div class="block-title">作者名录（排名不分先后）</div>
            <div class="intro-content">
              <div class="section">王斯旻，Wendy Teo，邹乐勤，贾曼，张思达，付冲，张森，王子寒，王雨田，王一楠，金立晗，郑时翔，Honglin Li，Florence Lam，马欣然，岳子泓，吕嘉琦，宋蕾，赵芯妍，阳程帆，郑墨，邱璜，张砚，Dylan Dai，周宁奕，杨铭川，林宇腾，邓若凝，王梓如，张艺，刘鑫，赵皎月，李静姝，吴俊杰</div>
            </div>
          </div>
          <div class="main-block">
            <div class="block-title">内容节选</div>
            <div class="img-box">
              <img v-for="(item, index) in fantasyTwoImageList" :src="item" @click="preview(fantasyTwoImageList, index)">
              <!-- <image wx:for="{{fantasyTwoImageList}}" wx:key="item" src="{{item}}" mode="widthFix" bindtap="prediv" data-list="fantasyTwoImageList" data-item="{{item}}"></image> -->
            </div>
          </div>
        </div>
        <!-- 奇想1 -->
        <div class="book-block" v-if="currentBook == 1">
          <div class="main-block">
            <div class="block-title">基本信息</div>
            <div class="base-list">
              <div class="list-item">
                <div class="type">书名</div>
                <div class="content">《奇想：建筑 景观 城市创意设计选集 1》</div>
              </div>
              <div class="list-item">
                <div class="type">外文名</div>
                <div class="content">《Exacting Fantasy》</div>
              </div>
              <div class="list-item">
                <div class="type">主编</div>
                <div class="content">王斯旻，王雪诗，张隆川 [加]</div>
              </div>
              <div class="list-item">
                <div class="type">页数</div>
                <div class="content">201 页</div>
              </div>
              <div class="list-item">
                <div class="type">装订</div>
                <div class="content">平装</div>
              </div>
              <div class="list-item">
                <div class="type">出版社</div>
                <div class="content">清华大学出版社</div>
              </div>
              <div class="list-item">
                <div class="type">商品尺寸</div>
                <div class="content">15.5 x 23 x 1.2 cm</div>
              </div>
            </div>
          </div>
          <div class="main-block">
            <div class="block-title">内容简介</div>
            <div class="intro-content">
              <div class="section">康奈尔建筑系主任和纽约知名设计师联名推荐，提升设计和欣赏水平，了解建筑景观设计新风潮，从看世界名校名所设计师们的最新作品开始。20个完整的设计，代表了中国年轻海外设计师的较高水平，这些设计在不同尺度，不同风格，考虑并试图解决了不同的问题。从高清大图到中英文设计思路解析，让你了解名校名所设计师的思路和表现手法，让你知道设计用中文怎么叙述，用英文如何描述，让你知道世界各地的华人大牛们在世界名校名所中，有什么不同的表现和担当。</div>
            </div>
          </div>
          <div class="main-block">
            <div class="block-title">内容节选</div>
            <div class="img-box">
              <img v-for="(item, index) in fantasyOneImageList" :src="item" @click="preview(fantasyOneImageList, index)">
              <!-- <image wx:for="{{fantasyOneImageList}}" wx:key="item" src="{{item}}" mode="widthFix" bindtap="prediv" data-list="fantasyOneImageList" data-item="{{item}}"></image> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed-button">
      <button class="buy-dialog-button" @click="showDialog = true" disabled>立即购买</button>
    </div>
    <!-- 底部弹窗 -->
    <van-popup position="bottom" class="book-popup" v-model="showDialog">
      <div class="dialog-header">
        <div class="dialog-cover">
          <img src="/Application/Home/Resource/mini-program-static/book/cover-two-small.jpg" mode="widthFix" v-if="selectedBook == 1">
          <img src="/Application/Home/Resource/mini-program-static/book/cover-combo-small.jpg" mode="widthFix" v-if="selectedBook == 2">
          <img src="/Application/Home/Resource/mini-program-static/book/cover-one-small.jpg" mode="widthFix" v-if="selectedBook == 3">
        </div>
        <div class="header-info">
          <div class="title">《奇想·建筑》</div>
          <div class="header-price">¥ {{bookData[selectedBook - 1].salePrice}}</div>
        </div>
      </div>
      <div class="book-choose">
        <div class="choose-title">购买版本</div>
        <div class="choose-wrapper">
          <div class="choose-item" :class="{'selected': selectedBook == item.id, 'disabled': item.soldOut}" v-for="item in bookData" @click="chooseBook(item)">{{item.title}}</div>
        </div>
      </div>
      <div class="buy-control">
        <div class="control-type">购买数量</div>
        <div class="num-picker">
          <div class="control-button subtract" :class="{'disabled': bookNum <= 1}" :disabled="bookNum <= 1" @click="changeNum('subtract')">
            <span class="subtract-icon"></span>
          </div>
          <input type="number" class="num-input" v-model="bookNum" @blur="numBlur">
          <div class="control-button add" @click="changeNum('add')">
            <span class="add-icon"></span>
          </div>
        </div>
      </div>
      <!-- <div class="buy-tips">一次性购买 10 本以上享折扣，请联系微信 Canopy2013</div> -->
      <div class="order-button-box"><button class="order-button" @click="confirmOrder">立即购买</button></div>
    </van-popup>
    <!-- 图片预览 -->
    <van-image-preview v-model="previewShow" :images="previewImageList" :start-position="imageIndex"></van-image-preview>
  </div>
</template>

<style lang="less" scoped>
  .book-wrapper{
    background: #F3F3F3;
    .book-cover{
      width: 100%;
      height: 320px;
      overflow: hidden;
      img{
        width: 100%;
      }
    }
    .book-intro{
      padding: 20px 15px;
      background: #fff;
      .title{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 16px;
        line-height: 16px;
        color: #333;
        font-weight: bold;
        span{
          width: 56px;
          height: 18px;
          line-height: 18px;
          background: #F85C5C;
          color: #fff;
          text-align: center;
          font-size: 12px;
          font-weight: normal;
          margin-right: 8px;
        }
      }
      .sub-title{
        margin-top: 8px;
        font-size: 12px;
        line-height: 12px;
        color: #999;
      }
      .price{
        margin-top: 8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 20px;
        line-height: 20px;
        font-weight: bold;
        color: @error;
        span{
          font-size: 14px;
          line-height: 14px;
          padding-top: 3px;
          color: #999;
          text-decoration: line-through;
          font-weight: normal;
          margin-left: 11px;
        }
      }
      .intro-item{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        font-size: 12px;
        line-height: 12px;
        overflow: hidden;
        &.post-cast{
          padding: 20px 0 16px;
          border-bottom: 1px solid #F3F3F3;
        }
        &.post-time{
          padding-top: 16px;
          height: auto;
        }
        .type{
          color: #999;
          margin-right: 12px;
          height: 12px;
          width: 48px;
          min-width: 48px;
          text-align: justify;
          &::after{
            content: ' ';
            display: inline-block;
            width: 100%;
          }
        }
        .content{
          width: calc(100% - 48px);
          word-break: break-all;
          &.warn{
            color: @error;
            line-height: 18px;
            margin-top: -3px;
          }
        }
      }
    }
    .book-main{
      margin-top: 16px;
      background: #fff;
      .book-switch{
        height: 42px;
        .switch-wrapper{
          position: relative;
          box-sizing: border-box;
          background: #FFF;
          padding: 0 15px;
          border-bottom: 2px solid #F3F3F3;
          &.fixed{
            position: fixed;
            top: 87px;
            left: 0;
            width: 100%;
            z-index: 100;
          }
          .switch-box{
            position: relative;
            line-height: 42px;
            display: flex;
            justify-content: center;
            align-items: center;
            .switch-item{
              width: 50%;
              font-size: 14px;
              color: #666;
              text-align: center;
              &.active{
                color: @cano;
              }
            }
            .active-line{
              position: absolute;
              top: 100%;
              left: 25%;
              width: 48px;
              height: 2px;
              background: @cano;
              transform: translateX(-50%);
              transition: all .2s;
            }
          }
        }
      }
      .book-block{
        padding-bottom: 50px;
        .main-block{
          padding: 20px 0;
          margin: 0 15px;
          border-bottom: 1px solid #F6F7F8;
          .block-title{
            font-size: 16px;
            line-height: 16px;
            font-weight: bold;
            color: #333;
          }
          .base-list{
            margin-top: 16px;
            .list-item{
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 14px;
              line-height: 14px;
              margin-bottom: 16px;
              color: #333;
              &:last-child{
                margin-bottom: 0;
              }
              .type{
                color: #999;
              }
            }
          }
          .intro-content{
            margin-top: 14px;
            .section{
              font-size: 16px;
              line-height: 24px;
              color: #666;
              margin-bottom: 24px;
              &:last-child{
                margin-bottom: 0;
              }
            }
          }
          .img-box{
            margin-top: 16px;
            img{
              width: 100%;
              margin-bottom: 4px;
            }
          }
        }
      }
    }
    .fixed-button{
      box-sizing: border-box;
      width: 100%;
      position: fixed;
      left: 0;
      bottom: 0;
      padding: 0 15px 12px;
    }
    .fixed-button .buy-dialog-button{
      width: 100%;
      height: 44px;
      font-size: 16px;
      line-height: 44px;
      color: #fff;
      background: @cano;
      border: 0;
      box-shadow: 0 4px 10px 0 rgba(77,162,199,.3);
      border-radius: 44px;
      transition: all .2s ease;
      &:active{
        opacity: .8;
      }
      &:disabled{
        background: #EEE;
        color: #999;
      }
    }
    .book-popup{
      overflow-y: unset;
      padding: 0 20px;
      .dialog-header{
        position: relative;
        padding-bottom: 16px;
        border-bottom: 1px solid #F3F3F3;
        .dialog-cover{
          position: absolute;
          left: 0;
          top: 0;
          transform: translateY(-40%);
          width: 96px;
          height: 96px;
          border: 1px solid #CCC;
          background: #FFF;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .header-info{
          padding: 20px 0 0 108px;
          .title{
            font-size: 14px;
            line-height: 14px;
            font-weight: bold;
            color: #333;
          }
          .header-price{
            font-size: 18px;
            line-height: 18px;
            margin-top: 8px;
            color: #F85C5C;
          }
        }
      }
      .book-choose{
        margin-top: 20px;
        .choose-title{
          font-size: 14px;
          line-height: 14px;
          color: #666;
        }
        .choose-wrapper{
          padding-top: 4px;
          display: flex;
          flex-wrap: wrap;
          .choose-item{
            box-sizing: border-box;
            margin-top: 12px;
            padding: 0 10px;
            border: 1px solid #999;
            color: #999;
            font-size: 14px;
            line-height: 26px;
            height: 28px;
            margin-right: 16px;
            border-radius: 4px;
            transition: all .2s;
            &.selected{
              border-color: @cano;
              background: @cano;
              color: #FFF;
            }
            &.disabled{
              position: relative;
              border-color: #999;
              color: #999;
              background: #EEE;
              cursor: not-allowed;
              overflow: visible;
              &::after{
                content: '缺货';
                position: absolute;
                top: -10px;
                right: -8px;
                background: @cano;
                color: #FFF;
                font-size: 12px;
                line-height: 12px;
                padding: 2px 4px;
                border-radius: 2px;
              }
            }
          }
        }
      }
      .buy-control{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 24px;
        .control-type{
          font-size: 14px;
          color: #666;
        }
        .num-picker{
          position: relative;
          box-sizing: border-box;
          width: 120px;
          height: 32px;
          border: 1px solid #DCDFE6;
          overflow: hidden;
          border-radius: 4px;
          .control-button{
            position: absolute;
            top: 0;
            width: 36px;
            height: 100%;
            background: #F5F7FA;
            &.subtract{
              left: 0;
              border-right: 1px solid #D8DCE6;
            }
            &.add{
              right: 0;
              border-left: 1px solid #D8DCE6;
            }
            &:disabled,
            &.disabled{
              .subtract-icon::after,
              .add-icon::after,
              .add-icon::before{
                background: #C0C4CC;
              }
            }
          }
          .num-input{
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            text-align: center;
            padding: 0 36px;
            font-size: 14px;
            color: #333;
            line-height: 30px;
          }
        }
        .subtract-icon::after{
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 10px;
          height: 2px;
          background: #666;
        }
        .add-icon::after{
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 10px;
          height: 2px;
          background: #666;
        }
        .add-icon::before{
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 2px;
          height: 10px;
          background: #666;
        }
      }
      .buy-tips{
        text-align: right;
        font-size: 12px;
        line-height: 12px;
        margin-top: 12px;
        color: #999;
      }
      .order-button-box{
        width: 100%;
        margin: 20px 0;
        .order-button{
          width: 100%;
          height: 44px;
          font-size: 16px;
          line-height: 44px;
          color: #fff;
          background: @cano;
          border: 0;
          box-shadow: 0 4px 10px 0 rgba(77,162,199,.3);
          border-radius: 44px;
          transition: all .2s ease;
          &:active{
            opacity: .8;
          }
        }
      }
    }
  }
</style>

<style lang="less" scoped></style>

<script type="text/javascript">
  export default {
    data() {
      return {
        isFestival: false,
        bookNum: 1,
        selectedBook: 1,
        currentBook: 2,
        switchLeft: 25,
        tabOffset: 0,
        switchFixed: false,
        showDialog: false,
        bookData: [{
          id: 1,
          title: '奇想·建筑',
          salePrice: '29.90',
          normalPrice: '118.00',
          thumb: '/pages/images/book/cover-two-small.jpg',
          soldOut: false
        }, {
          id: 2,
          title: '奇想系列 1+2',
          salePrice: '78.80',
          normalPrice: '197.00',
          thumb: '/pages/images/book/cover-combo-small.jpg',
          soldOut: true
        }, {
          id: 3,
          title: '奇想：建筑 景观 城市创意设计选集 1',
          salePrice: '58.80',
          normalPrice: '79.00',
          thumb: '/pages/images/book/cover-one-small.jpg',
          soldOut: true
        }],
        previewShow: false,
        imageIndex: 0,
        previewImageList: [],
      }
    },
    computed: {
      fantasyTwoImageList() {
        let list = []
        for(let i = 1; i <= 8;i++) {
          list.push(`/Application/Home/Resource/mini-program-static/book/fantasy-page${i}.png`)
        }
        return list;
      },
      fantasyOneImageList() {
        let list = []
        for(let i = 1; i <= 6;i++) {
          list.push(`/Application/Home/Resource/mini-program-static/book/fantasy-one-page${i}.png`)
        }
        return list;
      }
    },
    created() {
      this.$store.commit('setActiveMenu', 'book');
    },
    mounted() {
      this.getTabOffset();
      window.addEventListener('scroll', () => {
        this.scrollAction();
      })
      this.scrollAction();
    },
    methods: {
      getTabOffset() {
        this.tabOffset = $('#bookSwitch').offset().top;
      },
      scrollAction() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop >= this.tabOffset) {
          this.switchFixed = true;
        }else {
          this.switchFixed = false;
        }
      },
      preview(list, index) {
        this.previewImageList = list;
        this.previewShow = true;
        this.imageIndex = index;
      },
      // 切换奇想介绍tab
      changePage(bookVersion) {
        this.switchLeft = bookVersion == 2 ? 25 : 75;
        this.currentBook = bookVersion;

        this.$nextTick(() => {
          $('html, body').animate({scrollTop: this.tabOffset}, 300);
        })
      },
      chooseBook(book) {
        if(book.soldOut) return;
        this.selectedBook = book.id;
      },
      changeNum(type) {
        switch(type) {
          case 'subtract': {
            if(this.bookNum <= 1) return;
            this.bookNum -= 1;
          };break;
          case 'add': {
            this.bookNum += 1;
          }
        }
      },
      numBlur() {
        if(!this.bookNum || this.bookNum <= 0) {
          this.bookNum = 1;
        }
      },
      confirmOrder() {
        this.$router.push({path: '/book/order', query: {num: this.bookNum, type: this.selectedBook}})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Book/index.vue